import Vue from 'vue'
import Router from 'vue-router'

const Description = () => import('@/views/description')
const Law = () => import('@/views/law')
const Form = () => import('@/views/form')
const Success = () => import('@/views/success')
const Search = () => import('@/views/search')
const History = () => import('@/views/history')
const Index = () => import('@/views/index')
const Redirect = () => import('@/views/redirect')
Vue.use(Router)

export default new Router({
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  mode: 'history',
  base: '/thirdpartytournament/',
  routes: [{
    path: '/description',
    name: 'description',
    component: Description
  }, {
    path: '/apply',
    name: 'law',
    component: Law
  }, {
    path: '/form',
    name: 'form',
    component: Form
  }, {
    path: '/success',
    name: 'success',
    component: Success
  }, {
    path: '/search',
    name: 'search',
    component: Search
  }, {
    path: '/history',
    name: 'history',
    component: History
  },
  {
    path: '/index',
    name: 'index',
    component: Index
  },{
    path: '*',
    name: 'redirect',
    component: Redirect
  }]
})
